<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9200_94745)">
      <rect x="8.01367"
            y="2.17188"
            width="15.9219"
            height="27.9375"
            rx="1.6"
            fill="url(#paint0_linear_9200_94745)"
      />
      <rect x="8.01367"
            y="2.17188"
            width="15.9219"
            height="27.9375"
            rx="1.6"
            fill="url(#paint1_radial_9200_94745)"
      />
      <rect x="8.01367"
            y="2.17188"
            width="15.9219"
            height="27.9375"
            rx="1.6"
            fill="url(#paint2_linear_9200_94745)"
      />
      <rect x="8.01367"
            y="2.17188"
            width="15.9219"
            height="27.9375"
            rx="1.6"
            fill="url(#paint3_radial_9200_94745)"
      />
      <rect x="8.01367"
            y="2.17188"
            width="15.9219"
            height="27.9375"
            rx="1.6"
            fill="url(#paint4_linear_9200_94745)"
      />
      <rect x="8.01367"
            y="2.17188"
            width="15.9219"
            height="27.9375"
            rx="1.6"
            fill="url(#paint5_linear_9200_94745)"
      />
      <rect x="8.01367"
            y="2.17188"
            width="15.9219"
            height="27.9375"
            rx="1.6"
            fill="url(#paint6_linear_9200_94745)"
      />
      <rect x="8.01367"
            y="2.17188"
            width="15.9219"
            height="27.9375"
            rx="1.6"
            fill="url(#paint7_radial_9200_94745)"
      />
      <rect x="9.83789"
            y="4.14453"
            width="12.3242"
            height="8.80078"
            rx="1.4"
            fill="url(#paint8_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="4.14453"
            width="12.3242"
            height="8.80078"
            rx="1.4"
            fill="url(#paint9_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="4.14453"
            width="12.3242"
            height="8.80078"
            rx="1.4"
            fill="url(#paint10_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="4.14453"
            width="12.3242"
            height="8.80078"
            rx="1.4"
            fill="url(#paint11_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="4.14453"
            width="12.3242"
            height="8.80078"
            rx="1.4"
            fill="url(#paint12_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="4.14453"
            width="12.3242"
            height="8.80078"
            rx="1.4"
            fill="url(#paint13_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="4.14453"
            width="12.3242"
            height="8.80078"
            rx="1.4"
            fill="url(#paint14_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="4.14453"
            width="12.3242"
            height="8.80078"
            rx="1.4"
            fill="url(#paint15_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="4.14453"
            width="12.3242"
            height="8.80078"
            rx="1.4"
            fill="url(#paint16_radial_9200_94745)"
      />
      <rect x="9.83789"
            y="4.14453"
            width="12.3242"
            height="8.80078"
            rx="1.4"
            fill="url(#paint17_radial_9200_94745)"
      />
      <rect x="9.83789"
            y="4.14453"
            width="12.3242"
            height="8.80078"
            rx="1.4"
            fill="url(#paint18_radial_9200_94745)"
      />
      <rect x="9.83789"
            y="4.14453"
            width="12.3242"
            height="8.80078"
            rx="1.4"
            fill="url(#paint19_radial_9200_94745)"
      />
      <rect x="9.83789"
            y="16.1875"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint20_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="16.1875"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint21_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="16.1875"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint22_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="16.1875"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint23_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="16.1875"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint24_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="16.1875"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint25_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="16.1875"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint26_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="16.1875"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint27_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="16.1875"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint28_radial_9200_94745)"
      />
      <rect x="9.83789"
            y="16.1875"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint29_radial_9200_94745)"
      />
      <rect x="9.83789"
            y="16.1875"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint30_radial_9200_94745)"
      />
      <rect x="9.83789"
            y="16.1875"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint31_radial_9200_94745)"
      />
      <rect x="9.83789"
            y="23.1367"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint32_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="23.1367"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint33_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="23.1367"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint34_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="23.1367"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint35_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="23.1367"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint36_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="23.1367"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint37_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="23.1367"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint38_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="23.1367"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint39_linear_9200_94745)"
      />
      <rect x="9.83789"
            y="23.1367"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint40_radial_9200_94745)"
      />
      <rect x="9.83789"
            y="23.1367"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint41_radial_9200_94745)"
      />
      <rect x="9.83789"
            y="23.1367"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint42_radial_9200_94745)"
      />
      <rect x="9.83789"
            y="23.1367"
            width="12.3242"
            height="4.85938"
            rx="1.4"
            fill="url(#paint43_radial_9200_94745)"
      />
      <circle cx="22.1621"
              cy="14.5898"
              r="1.02344"
              fill="url(#paint44_radial_9200_94745)"
      />
      <circle cx="22.1621"
              cy="14.5898"
              r="1.02344"
              fill="url(#paint45_radial_9200_94745)"
      />
      <circle cx="22.1621"
              cy="14.5898"
              r="1.02344"
              fill="url(#paint46_radial_9200_94745)"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_9200_94745"
                      x1="15.9746"
                      y1="2.17187"
                      x2="15.9746"
                      y2="30.1094"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DA9662" />
        <stop offset="1"
              stop-color="#D58763"
        />
      </linearGradient>
      <radialGradient id="paint1_radial_9200_94745"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(23.9355 2.64927) rotate(137.527) scale(2.60094 2.379)"
      >
        <stop offset="0.0393727"
              stop-color="#E8A66F"
        />
        <stop offset="1"
              stop-color="#E8A66F"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint2_linear_9200_94745"
                      x1="8.01367"
                      y1="12.0914"
                      x2="9.85493"
                      y2="12.0914"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A56F56" />
        <stop offset="0.782609"
              stop-color="#C98355"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint3_radial_9200_94745"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(21.8824 14.7626) rotate(130.641) scale(1.98266 1.77214)"
      >
        <stop offset="0.385675"
              stop-color="#C76B48"
        />
        <stop offset="0.721001"
              stop-color="#C76B48"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint4_linear_9200_94745"
                      x1="24.0525"
                      y1="17.432"
                      x2="22.319"
                      y2="17.432"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D79965" />
        <stop offset="0.325809"
              stop-color="#E59F6A"
        />
        <stop offset="1"
              stop-color="#E59F6A"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_9200_94745"
                      x1="15.9746"
                      y1="2.17187"
                      x2="15.9746"
                      y2="30.8025"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.912677"
              stop-color="#BA625A"
              stop-opacity="0"
        />
        <stop offset="0.995644"
              stop-color="#BA625A"
        />
      </linearGradient>
      <linearGradient id="paint6_linear_9200_94745"
                      x1="15.9746"
                      y1="2.17187"
                      x2="15.9746"
                      y2="30.1094"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C98C58" />
        <stop offset="0.051065"
              stop-color="#C98C58"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint7_radial_9200_94745"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.9746 16.1406) rotate(90) scale(13.9688 7.96094)"
      >
        <stop stop-color="#DD9364" />
        <stop offset="1"
              stop-color="#DD9364"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint8_linear_9200_94745"
                      x1="9.83789"
                      y1="8.85937"
                      x2="22.1621"
                      y2="8.85938"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CC8D6A" />
        <stop offset="1"
              stop-color="#C48462"
        />
      </linearGradient>
      <linearGradient id="paint9_linear_9200_94745"
                      x1="9.83789"
                      y1="8.99883"
                      x2="11.2473"
                      y2="8.99883"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CC906A" />
        <stop offset="1"
              stop-color="#CC906A"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint10_linear_9200_94745"
                      x1="11.2473"
                      y1="12.9453"
                      x2="11.2473"
                      y2="11.2303"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.315214"
              stop-color="#CC906A"
        />
        <stop offset="1"
              stop-color="#CC906A"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint11_linear_9200_94745"
                      x1="16"
                      y1="3.58844"
                      x2="16"
                      y2="12.9453"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B76747" />
        <stop offset="0.183052"
              stop-color="#B76747"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint12_linear_9200_94745"
                      x1="16"
                      y1="3.58844"
                      x2="16"
                      y2="12.9453"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B76747" />
        <stop offset="0.183052"
              stop-color="#B76747"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint13_linear_9200_94745"
                      x1="17.3662"
                      y1="13.1214"
                      x2="17.3662"
                      y2="4.14453"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C27C45" />
        <stop offset="0.11255"
              stop-color="#C27C45"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint14_linear_9200_94745"
                      x1="9.83789"
                      y1="9.61435"
                      x2="15.7171"
                      y2="9.61435"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C27C45" />
        <stop offset="0.110304"
              stop-color="#C27C45"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint15_linear_9200_94745"
                      x1="22.1621"
                      y1="8.54492"
                      x2="15.3303"
                      y2="8.54492"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B76747" />
        <stop offset="0.180812"
              stop-color="#B76747"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint16_radial_9200_94745"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(21.2841 4.58098) rotate(122.282) scale(9.89363 13.8546)"
      >
        <stop stop-color="#B86A4A" />
        <stop offset="0.118379"
              stop-color="#B86A4A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint17_radial_9200_94745"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(10.4939 12.5522) rotate(-35.0256) scale(12.9208 18.0937)"
      >
        <stop stop-color="#C27C45" />
        <stop offset="0.0695929"
              stop-color="#C27C45"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint18_radial_9200_94745"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(11.235 11.7368) rotate(6.66663) scale(1.1607 1.22387)"
      >
        <stop stop-color="#C98967" />
        <stop offset="1"
              stop-color="#C98967"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint19_radial_9200_94745"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.5477 11.5122) rotate(-127.807) scale(1.0991 1.02217)"
      >
        <stop stop-color="#C68664" />
        <stop offset="1"
              stop-color="#C48362"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint20_linear_9200_94745"
                      x1="9.83789"
                      y1="18.7908"
                      x2="22.1621"
                      y2="18.7908"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CC8D6A" />
        <stop offset="1"
              stop-color="#C48462"
        />
      </linearGradient>
      <linearGradient id="paint21_linear_9200_94745"
                      x1="10.2718"
                      y1="18.8678"
                      x2="11.9677"
                      y2="18.8678"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CC906A" />
        <stop offset="1"
              stop-color="#CC906A"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint22_linear_9200_94745"
                      x1="11.2473"
                      y1="21.0469"
                      x2="11.2473"
                      y2="20.0999"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.315214"
              stop-color="#CC906A"
        />
        <stop offset="1"
              stop-color="#CC906A"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint23_linear_9200_94745"
                      x1="16"
                      y1="15.8805"
                      x2="16"
                      y2="21.0469"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B76747" />
        <stop offset="0.183052"
              stop-color="#B76747"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint24_linear_9200_94745"
                      x1="16"
                      y1="15.8805"
                      x2="16"
                      y2="21.0469"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B76747" />
        <stop offset="0.255996"
              stop-color="#B76747"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint25_linear_9200_94745"
                      x1="17.3662"
                      y1="21.1441"
                      x2="17.3662"
                      y2="16.1875"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C27C45" />
        <stop offset="0.11255"
              stop-color="#C27C45"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint26_linear_9200_94745"
                      x1="9.83789"
                      y1="19.2077"
                      x2="15.7171"
                      y2="19.2077"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C27C45" />
        <stop offset="0.110304"
              stop-color="#C27C45"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint27_linear_9200_94745"
                      x1="22.1621"
                      y1="18.6172"
                      x2="15.3303"
                      y2="18.6172"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B76747" />
        <stop offset="0.180812"
              stop-color="#B76747"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint28_radial_9200_94745"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-5.28411 4.61839 -11.713 -4.08572 21.2841 16.4285)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B86A4A" />
        <stop offset="0.118379"
              stop-color="#B86A4A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint29_radial_9200_94745"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(10.5808 -4.09465 10.3847 8.18117 10.4939 20.8298)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C27C45" />
        <stop offset="0.0695929"
              stop-color="#C27C45"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint30_radial_9200_94745"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(1.15286 0.0744018 -0.142082 0.671196 11.235 20.3796)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C98967" />
        <stop offset="1"
              stop-color="#C98967"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint31_radial_9200_94745"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-0.673746 -0.479481 0.807603 -0.345973 20.5477 20.2556)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C68664" />
        <stop offset="1"
              stop-color="#C48362"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint32_linear_9200_94745"
                      x1="9.83789"
                      y1="25.74"
                      x2="22.1621"
                      y2="25.74"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CC8D6A" />
        <stop offset="1"
              stop-color="#C48462"
        />
      </linearGradient>
      <linearGradient id="paint33_linear_9200_94745"
                      x1="10.2718"
                      y1="25.817"
                      x2="11.9677"
                      y2="25.817"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CC906A" />
        <stop offset="1"
              stop-color="#CC906A"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint34_linear_9200_94745"
                      x1="11.2473"
                      y1="27.9961"
                      x2="11.2473"
                      y2="27.0491"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.315214"
              stop-color="#CC906A"
        />
        <stop offset="1"
              stop-color="#CC906A"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint35_linear_9200_94745"
                      x1="16"
                      y1="22.8297"
                      x2="16"
                      y2="27.9961"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B76747" />
        <stop offset="0.183052"
              stop-color="#B76747"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint36_linear_9200_94745"
                      x1="16"
                      y1="22.8297"
                      x2="16"
                      y2="27.9961"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B76747" />
        <stop offset="0.255996"
              stop-color="#B76747"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint37_linear_9200_94745"
                      x1="17.3662"
                      y1="28.0933"
                      x2="17.3662"
                      y2="23.1367"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C27C45" />
        <stop offset="0.11255"
              stop-color="#C27C45"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint38_linear_9200_94745"
                      x1="9.83789"
                      y1="26.1569"
                      x2="15.7171"
                      y2="26.1569"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C27C45" />
        <stop offset="0.110304"
              stop-color="#C27C45"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint39_linear_9200_94745"
                      x1="22.1621"
                      y1="25.5664"
                      x2="15.3303"
                      y2="25.5664"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B76747" />
        <stop offset="0.180812"
              stop-color="#B76747"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint40_radial_9200_94745"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-5.28411 4.61839 -11.713 -4.08572 21.2841 23.3777)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B86A4A" />
        <stop offset="0.118379"
              stop-color="#B86A4A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint41_radial_9200_94745"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(10.5808 -4.09465 10.3847 8.18117 10.4939 27.779)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C27C45" />
        <stop offset="0.0695929"
              stop-color="#C27C45"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint42_radial_9200_94745"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(1.15286 0.0744018 -0.142082 0.671196 11.235 27.3288)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C98967" />
        <stop offset="1"
              stop-color="#C98967"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint43_radial_9200_94745"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-0.673746 -0.479481 0.807603 -0.345973 20.5477 27.2048)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C68664" />
        <stop offset="1"
              stop-color="#C48362"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint44_radial_9200_94745"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(22.7012 14) rotate(118.044) scale(1.8279)"
      >
        <stop offset="0.242049"
              stop-color="#FFB62F"
        />
        <stop offset="0.90503"
              stop-color="#E07124"
        />
      </radialGradient>
      <radialGradient id="paint45_radial_9200_94745"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(22.6387 14.2812) rotate(131.634) scale(0.94075)"
      >
        <stop offset="0.166667"
              stop-color="#FFCB6E"
        />
        <stop offset="1"
              stop-color="#FEA32F"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint46_radial_9200_94745"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(22.8574 14.5898) rotate(180) scale(1.92187)"
      >
        <stop offset="0.681818"
              stop-color="#F0972A"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#D37D22"
        />
      </radialGradient>
      <clipPath id="clip0_9200_94745">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
